"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import BaseToolbarButtonProp from "./BaseToolbarButton";
import { Messages } from "Messages";
import { tbShowColumnChooserBtnClicked, ttbResetTableSettings } from "Actions/Table/TableToolBarActions";

var PreferencesButtonProp =
/*#__PURE__*/
function (_BaseToolbarButtonPro) {
  _inherits(PreferencesButtonProp, _BaseToolbarButtonPro);

  function PreferencesButtonProp(_ref) {
    var _this;

    var _formUUID = _ref.formUUID,
        isContextMenu = _ref.isContextMenu,
        rest = _objectWithoutProperties(_ref, ["formUUID", "isContextMenu"]);

    _classCallCheck(this, PreferencesButtonProp);

    var props = _objectSpread({
      iconType: 'material:settings',
      hint: Messages.Controls.Preferences,
      isContextMenu: isContextMenu
    }, rest);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PreferencesButtonProp).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "updateUUID", function (formUUID) {
      _this.UUID = formUUID;
    });

    _this.target = "".concat(_formUUID, "-preferences");
    _this.UUID = _formUUID;
    _this._props.updateUUID = _this.updateUUID;
    return _this;
  }

  _createClass(PreferencesButtonProp, [{
    key: "onItemClick",
    value: function onItemClick(_ref2) {
      var itemData = _ref2.itemData;
      this.delegateClick(itemData);
    }
  }, {
    key: "itemTemplate",
    value: function itemTemplate(data, index, element) {
      var result = $("<div>").addClass('d5popover-with-list-li');

      if (!data.name) {
        return "<span class=\"icon menu-dpdown\" id=\"".concat(this.target, "\"><i class=\"material-icons\">settings</i></span>");
      }

      $("<div>").addClass("dx-icon dx-icon-".concat(data.iconSrc)).appendTo(result);
      $("<div>").text(data.name).appendTo(result);
      element.hover(function () {
        $(this).css('background-color', '#f2f2f2');
      }, function () {
        $(this).css('background-color', '');
      });
      return result.appendTo(element);
    }
  }, {
    key: "delegateClick",
    value: function delegateClick(item) {
      switch (item.id) {
        case 'reset':
          ttbResetTableSettings({
            formUUID: this.UUID
          });
          break;

        case 'chooser':
          tbShowColumnChooserBtnClicked({
            formUUID: this.UUID
          });
          break;
      }
    }
  }, {
    key: "template",
    value: function template(data, contentElement) {
      var _this2 = this;

      this.$btn = $('<div class="custom-dropdown-menu">').dxMenu({
        dataSource: [{
          id: 1,
          items: [{
            id: "chooser",
            name: Messages.Controls.ColumnChooser,
            iconSrc: "column-chooser"
          }, {
            id: "reset",
            name: Messages.Controls.ResetAllSettings,
            iconSrc: "revert"
          }]
        }],
        itemTemplate: this.itemTemplate.bind(this),
        onItemClick: function onItemClick(e) {
          return _this2.onItemClick(e);
        },
        selectionMode: "single"
      });
      return this.$btn;
    }
  }]);

  return PreferencesButtonProp;
}(BaseToolbarButtonProp);

_defineProperty(PreferencesButtonProp, "create", function (options) {
  return new PreferencesButtonProp(options).props();
});

export { PreferencesButtonProp as default };